module.exports = __webpack_public_path__ + "img/2.7b39d2f9.png";